import { GrowthBook } from '@growthbook/growthbook-react';
import * as experimentationService from 'services/experimentation';
class EcsExperimentationFramework extends GrowthBook {
  #user: any;
  // eslint-disable-next-line no-shadow
  constructor(context) {
    super(context);
    this.getFeatures();
  }

  /**
   * Set user
   * @param user
   */
  setUser(user) {
    this.#user = user;
    this.setAttributes({
      user_id: user.id,
      role: user.role,
      email: user.email,
    });
    this.getFeatures();
  }

  async getFeatures() {
    try {
      const res = await experimentationService.getAllFeatures();
      this.setFeatures(res.features);
    } catch (err) {
      console.error(`Feature Fetched error`, err);
    }
  }
}

// eslint-disable-next-line import/prefer-default-export
export const ecsExperimentationFramework = new EcsExperimentationFramework();
